import { mapGetters }           from "vuex"
import {
    ErrorLogService,
    PartSearchService,
    CatalogService }         from "@/services/";
import { IPartSearchRequest }   from "@/types";
import { brandAndRegionAuthHelper } from "@/components/mixins"

export const partSearch = {
    mixins: [brandAndRegionAuthHelper],
    data: () => ({
    }),
    computed: {
        ...mapGetters([
            "activeAccountId",
            "audienceAndExclusions",
            "audienceIds"
        ])
    },
    methods: {
        async searchParts(partPage: number, xrefPage: number, searchTerm: string, isQuerySearch: {type: boolean, default: true}) {
            try {
                if( searchTerm === '*'){
                    return;
                }
                let searchResults = await this.getPartResults(partPage, xrefPage, searchTerm);
                // Need to use transformed OemPartCode (e.g. "A123" to "A00000123")
                // if no results or wildcard, then use searchTerm
                let oemPartCode = ( 
                    searchResults.data.PartSearchResults.PartResults.length > 0 && 
                    searchTerm.indexOf('*') < 0 )
                    ? searchResults.data.PartSearchResults.PartResults[0].OemPartCode
                    : searchTerm;

                // Send result to the store to use in part detail or search results
                this.$store.commit("SET_PART_SEARCH_DATA", { searchTerm: oemPartCode, data: searchResults });

                // set part and xref data, then check if we need to go directly to 
                let foundParts = searchResults.data.PartSearchResults.PartResults;
                let crossParts = searchResults.data.CrossReferenceSearchResult.CrossReferenceResults;
                let goToPartDetail = foundParts.length === 1 && (crossParts == null || crossParts?.length === 0);

                if (goToPartDetail && !isQuerySearch) {
                    this.RedirectToPartDetail(oemPartCode);
                    return;
                }

                //go to part detail if there is only one xref result
                let goToXrefPartDetail = crossParts?.length === 1 && (foundParts == null || foundParts.length === 0);
                
                if (goToXrefPartDetail && !isQuerySearch) {
                    var xrefOriginalOemPartCode = searchResults.data.CrossReferenceSearchResult.CrossReferenceResults[0].OriginalOemPartCode;
                    this.RedirectToPartDetail(xrefOriginalOemPartCode);
                    return;
                }

                // go to part search page
                this.$router.push({ 
                    name: "PartSearchPage", 
                    query: { searchTerm: searchTerm } 
                }).catch( error => {
                    if (error.name != "NavigationDuplicated") {
                        throw error;
                    } 
                });
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            }
        },
        async getPartResults(partPage: number, xrefPage: number, searchTerm: string, pageSize: number = 10) {
            let partSearchParams = {
                AccountId: this.activeAccountId,
                UserId: this.user.UserId,
                DealerCode: this.user.DealerCode,
                SearchTerm: searchTerm,
                PartPage: partPage,
                XrefPage: xrefPage,
                RunKeywordSearch: true,
                UserAudiences: this.audienceIds,
                KeywordSearchPageSize: pageSize
            } as IPartSearchRequest;

            let results = await PartSearchService.PartSearch(partSearchParams);

            return results;
        },

        async getCategories(searchTerm){
            this.searchResultsAreLoading = true;           
            var result = await CatalogService.GetCategoriesByKeyword(this.activeAccountId, this.user.UserId, searchTerm, this.audienceIds);
                var cats = result.data;
                var authorizedCats = cats.filter(meow => 
                  this.IsBrandRegionAuthorized(meow.BrandAuth, meow.RegionAuth)
                );
                return authorizedCats;
          },

        RedirectToPartDetail(searchTerm: String) {
            this.$router.push({ 
                name: 'PartDetails', 
                query: { oemPartCode: searchTerm } 
            }).catch(error => {
                if (error.name != "NavigationDuplicated") {
                    throw error;
                } 
            })
        },
    }
}